import Isotope from 'isotope-layout/dist/isotope.pkgd.min.js';
import 'Sass/views/majors-and-minors-landing-page.scss';

(function () {
    'use strict';

    function majorsMinors($scope) {

        const FILTER = '.major-minor-card';

        var vm = this,
            container = new Isotope(document.querySelector('.masonry-outer'), { // prefilter by major-minor-item is essential for later...
                itemSelector: '.isotope-item',
                filter: FILTER,
                getSortData: {
                    name: el => el.querySelector('h5').innerText                    
                },
                sortBy: 'name'
            });

        angular.extend(vm, {
            keyword: '',
            active: null,
            filter: filter,
            reset: reset
        });

        function reset() {
            container.arrange({ filter: FILTER });
            vm.keyword = '';
            vm.active = null;
        }

        function filter(type, value) {
            vm.active = value;
            container.arrange({ filter: '[data-filter*="' + type + '-' + value + '"]' });
        }

        $scope.$watch('vm.keyword', function (newVal, oldVal) {
            if (newVal !== undefined && oldVal !== undefined && newVal !== oldVal) {
                if (newVal.length > 2) {
                    container.arrange({ filter: '[data-filter*="' + searchable(newVal) + '"]' });
                }
                else if (newVal.length < 3 && newVal.length < oldVal.length) {
                    container.arrange({ filter: FILTER });
                }
            }
        });

        var searchable = function (str) {
            return str !== undefined ? str.replace(/\s/gi, '-').toLowerCase() : '';
        }        
    }

    angular.module('Uscapp').controller('majorsMinorsController', ['$scope', majorsMinors]);

}());